/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LowEnrollmentClassRow } from './LowEnrollmentClassRow';
import {
    LowEnrollmentClassRowFromJSON,
    LowEnrollmentClassRowFromJSONTyped,
    LowEnrollmentClassRowToJSON,
    LowEnrollmentClassRowToJSONTyped,
} from './LowEnrollmentClassRow';

/**
 * 
 * @export
 * @interface WidgetDataLowEnrollmentClassesWidgetData
 */
export interface WidgetDataLowEnrollmentClassesWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataLowEnrollmentClassesWidgetData
     */
    $type?: WidgetDataLowEnrollmentClassesWidgetDataTypeEnum;
    /**
     * 
     * @type {Array<LowEnrollmentClassRow>}
     * @memberof WidgetDataLowEnrollmentClassesWidgetData
     */
    items: Array<LowEnrollmentClassRow>;
}


/**
 * @export
 */
export const WidgetDataLowEnrollmentClassesWidgetDataTypeEnum = {
    LowEnrollmentClasses: 'low-enrollment-classes'
} as const;
export type WidgetDataLowEnrollmentClassesWidgetDataTypeEnum = typeof WidgetDataLowEnrollmentClassesWidgetDataTypeEnum[keyof typeof WidgetDataLowEnrollmentClassesWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataLowEnrollmentClassesWidgetData interface.
 */
export function instanceOfWidgetDataLowEnrollmentClassesWidgetData(value: object): value is WidgetDataLowEnrollmentClassesWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function WidgetDataLowEnrollmentClassesWidgetDataFromJSON(json: any): WidgetDataLowEnrollmentClassesWidgetData {
    return WidgetDataLowEnrollmentClassesWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataLowEnrollmentClassesWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataLowEnrollmentClassesWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'items': ((json['items'] as Array<any>).map(LowEnrollmentClassRowFromJSON)),
    };
}

export function WidgetDataLowEnrollmentClassesWidgetDataToJSON(json: any): WidgetDataLowEnrollmentClassesWidgetData {
    return WidgetDataLowEnrollmentClassesWidgetDataToJSONTyped(json, false);
}

export function WidgetDataLowEnrollmentClassesWidgetDataToJSONTyped(value?: WidgetDataLowEnrollmentClassesWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'items': ((value['items'] as Array<any>).map(LowEnrollmentClassRowToJSON)),
    };
}

